import { SITE_META, SITE_META_DETAILS } from '../config/api';
import { apiCall } from './api';

// Get site meta by site_id
export const getSiteMeta = async (site_id) => {
  try {
    if (!site_id) {
      throw new Error('site_id is required');
    }
    const endpoint = SITE_META_DETAILS.replace('{site_id}', site_id);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching site meta:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch site meta',
      data: null
    };
  }
};

// Update site meta by site_id
export const updateSiteMeta = async (siteMetaData, site_id) => {
  try {
    if (!site_id) {
      throw new Error('site_id is required');
    }
    
    console.log('🔄 updateSiteMeta called with:', {
      site_id,
      siteMetaData,
      endpoint: SITE_META_DETAILS.replace('{site_id}', site_id),
      method: 'PUT'
    });
    
    // Use PUT method with site_id in URL path
    const endpoint = SITE_META_DETAILS.replace('{site_id}', site_id);
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: siteMetaData
    });
    
    console.log('📡 updateSiteMeta response:', response);
    return response;
  } catch (error) {
    console.error('Error updating site meta:', error);
    return {
      success: false,
      error: error.message || 'Failed to update site meta',
      data: null
    };
  }
};

// Create new site meta
export const createSiteMeta = async (siteMetaData) => {
  try {
    const response = await apiCall(SITE_META, {
      method: 'POST',
      data: siteMetaData
    });
    return response;
  } catch (error) {
    console.error('Error creating site meta:', error);
    return {
      success: false,
      error: error.message || 'Failed to create site meta',
      data: null
    };
  }
};

// Get all site meta entries
export const getAllSiteMeta = async () => {
  try {
    const response = await apiCall(SITE_META, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching all site meta:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch site meta entries',
      data: null
    };
  }
};
